import { render } from "./CustomerChangePasswordComponent.vue?vue&type=template&id=0de31ada&ts=true"
import script from "./CustomerChangePasswordComponent.vue?vue&type=script&lang=ts"
export * from "./CustomerChangePasswordComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__